/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const RealizationLogTypeDto = {
    LeadAssigned: 'LEAD_ASSIGNED',
    LeadCleared: 'LEAD_CLEARED',
    ResponsibleAssigned: 'RESPONSIBLE_ASSIGNED',
    ResponsibleCleared: 'RESPONSIBLE_CLEARED',
    DepartmentDone: 'DEPARTMENT_DONE',
    DepartmentReopened: 'DEPARTMENT_REOPENED',
    DepartmentNotApplicable: 'DEPARTMENT_NOT_APPLICABLE',
    Downloaded: 'DOWNLOADED',
} as const;

export type RealizationLogTypeDto = typeof RealizationLogTypeDto[keyof typeof RealizationLogTypeDto];



